import * as React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Wrapper from '@components/Wrapper';
import Label from '@components/Label';
import IconLink from '@components/IconLink';
import PostAuthorHead from '../PostAuthor/postAuthorHead';
import PostFooter from '../PostFooter';
import AlternateVersionTag from '@components/AlternateVersionTag';
import * as styles from './style.module.scss';
// import * as sideBarStyles from '../PostSidebar/style.module.scss';

const {
  postHero,
  postHero__content,
  postHero__text,
  postHero__title,
  postHero__category,
  postHero__author,
  postHero__back,
  postHero__wrapper,
  postHero__introduction,
  postHero__version,
} = styles;

// const {
//   postSidebar__topCta,
//   postSidebar__ctaCard,
//   postSidebar__ctaTitle,
//   postSidebar__ctaBtnWrap,
//   postSidebar__ctaButton,
//   postSidebar__ctaBtnOuter,
//   postSidebar__ctaImage,
//   postSidebar__ctaTitleMob,
//   postSidebar__imgBtn,
// } = sideBarStyles;

const Hero = ({
  category,
  title,
  author,
  date,
  introduction,
  otherVersion,
  metaTitle,
  ctas,
  metaDescription,
  backUrl = '/blog/',
}) => {
  const { t } = useTranslation();

  return (
    <section className={postHero}>
      <Wrapper classes={postHero__wrapper}>
        <Label classes={postHero__category}>
          <IconLink
            classes={postHero__back}
            theme="reverse"
            withTail
            href={backUrl}
          >
            {t('play_breadcrumb_all')}
          </IconLink>
          <span className="blue-accent">{category.name}</span>
        </Label>
        <div className={postHero__content}>
          <div className={postHero__text}>
            <h1 className={postHero__title}>{title}</h1>
            <div
              className={postHero__introduction}
              dangerouslySetInnerHTML={{ __html: introduction }}
            />
            <div className={postHero__version}>
              {otherVersion && (
                <AlternateVersionTag resource={otherVersion[0]} />
              )}
              <div className={postHero__author}>
                <PostAuthorHead author={author} theme="simple" />·
                {date && <span>{date}</span>}
              </div>
            </div>
            <PostFooter
              metaTitle={metaTitle}
              metaDescription={metaDescription}
              size="small"
            />
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default Hero
